export const aboutContent = {
  hero: {
    title: '关于国产专区',
    subtitle: '让更多人发现国货之美，支持中国品牌走向世界',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20brand%20products%20displayed%20elegantly%20on%20a%20minimalist%20wooden%20surface%20with%20warm%20natural%20lighting%2C%20cream%20background%2C%20editorial%20brand%20photography%20with%20soft%20atmosphere&width=1200&height=500&seq=about-hero&orientation=landscape',
  },
  intro: {
    title: '我们的故事',
    paragraphs: [
      '国产专区创立于2020年，是国内领先的国货推荐与评测平台。我们的使命是"让更多人发现国货之美，支持中国品牌走向世界"。',
      '在过去的几年中，中国品牌在各个领域都取得了令人瞩目的成就。从国产美妆的国际认可到国产手机的技术突破，从国产食品的品质升级到国产服饰的国潮崛起，我们见证了无数国产品牌从模仿到创新、从跟跑到领跑的蜕变。',
      '国产专区致力于成为连接消费者与优质国货的桥梁。我们的团队由资深产品评测师、行业分析师和专业编辑组成，通过严谨的选品流程和客观的产品评测，为消费者提供最值得信赖的国货推荐。',
    ],
  },
  mission: {
    title: '我们的使命',
    items: [
      {
        icon: 'ri-search-eye-line',
        title: '严选好物',
        description: '从海量国货产品中，通过严格的标准筛选出真正值得推荐的好产品，让消费者省时省力地做出明智的购买决策。',
      },
      {
        icon: 'ri-file-text-line',
        title: '专业评测',
        description: '每一篇评测文章都经过实际使用和多维度对比分析，确保内容的客观、真实、有用，帮助消费者全面了解产品。',
      },
      {
        icon: 'ri-group-line',
        title: '连接品牌与消费者',
        description: '为优质国货品牌提供展示平台，帮助消费者发现更多优秀国产产品，促进供需双方的良性互动。',
      },
      {
        icon: 'ri-flag-2-line',
        title: '传播国货文化',
        description: '通过优质内容传播国货品牌的故事和文化，增强消费者对国产品牌的认同感和自豪感。',
      },
    ],
  },
  milestones: [
    { year: '2020年', event: '国产专区正式上线，首批收录100个国货品牌' },
    { year: '2021年', event: '月活用户突破10万，评测文章超过500篇' },
    { year: '2022年', event: '推出品牌排行榜和产品数据库，覆盖品类扩展至8大类' },
    { year: '2023年', event: '月活用户突破30万，成为国内领先的国货推荐平台' },
    { year: '2024年', event: '推出视频评测和直播推荐，与200+国货品牌建立合作关系' },
    { year: '2025年', event: '月活用户突破50万，累计评测文章超过2000篇' },
  ],
  testimonials: [
    {
      name: '李女士',
      role: '资深美妆博主',
      content: '国产专区是我每天必看的内容平台。他们的评测非常专业客观，帮我发现了很多宝藏国货品牌。国货真的是越来越好了！',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20in%20studio%2C%20warm%20lighting%2C%20cream%20background%2C%20professional%20headshot&width=100&height=100&seq=testimonial-1&orientation=squarish',
    },
    {
      name: '王先生',
      role: '数码产品爱好者',
      content: '作为一个数码发烧友，国产专区的评测文章帮助我理性消费。现在我的手机、耳机、手表全是国产品牌，体验一点都不比国外品牌差。',
      avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20in%20casual%20setting%2C%20warm%20lighting%2C%20cream%20background%2C%20professional%20headshot&width=100&height=100&seq=testimonial-2&orientation=squarish',
    },
    {
      name: '张女士',
      role: '新手妈妈',
      content: '从奶粉到辅食，从护肤品到日用品，我给宝宝和自己选的都是国货。国产专区的推荐非常靠谱，让我买得放心用得安心。',
      avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20in%20warm%20setting%2C%20friendly%20expression%2C%20cream%20background%2C%20professional%20headshot&width=100&height=100&seq=testimonial-3&orientation=squarish',
    },
  ],
  contact: {
    title: '联系我们',
    description: '如果您有任何关于国货产品的问题、品牌合作意向或内容建议，欢迎通过以下方式联系我们。我们期待与您的交流！',
    email: 'contact@guochanzhuanqu.cn',
    phone: '400-888-9999',
    address: '北京市朝阳区建国路88号国贸大厦A座',
    workingHours: '周一至周五 9:00 - 18:00',
  },
};